// Matching a time zone id to an entry of the app's timezone list (/cm/settings/timezones:
// [{name: "Asia/Kolkata", displayName: "(GMT+5:30) India Standard Time - Kolkata"}, …]).

// Zones known by two names. Browsers and the timezone list don't always agree — Edge reports
// "Asia/Calcutta" while the list has "Asia/Kolkata" — so look for either.
const ZONE_ALIASES = [
  ["Asia/Calcutta", "Asia/Kolkata"],
  ["Asia/Katmandu", "Asia/Kathmandu"],
  ["Asia/Rangoon", "Asia/Yangon"],
  ["Asia/Saigon", "Asia/Ho_Chi_Minh"],
  ["Europe/Kiev", "Europe/Kyiv"],
  ["America/Buenos_Aires", "America/Argentina/Buenos_Aires"],
  ["Etc/UTC", "UTC"]
];

// The list entry for a zone id, matching either of its names; null when the list doesn't have it.
export const findZoneOption = (tz, options = []) => {
  if (!tz) return null;
  const names = [tz];
  ZONE_ALIASES.forEach(pair => {
    if (pair.indexOf(tz) !== -1) names.push(...pair);
  });
  return (options || []).find(option => names.indexOf(option && option.name) !== -1) || null;
};

// This browser's time zone id ("Asia/Calcutta", "America/New_York"), or "" when unknown.
export const browserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (e) {
    return "";
  }
};
